import React, {useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SavePdfModal } from "../components/SavePdfModal";
import {
  Box,
  Button,
  Container,
  Typography,
  TextField,
  InputLabel,
  Stack,
} from "@mui/material";

const PreviewPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const canvasRef = useRef(null); 
 
  const { pins, lines, width = 600, height = 500, svg, debug, threadWidth  } = state || {}; 

 const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const [pendingFileName, setPendingFileName] = useState(
    "string_art_template.pdf" 
  );

   


  // ----------------- STRING ART RENDERING -----------------
  useEffect(() => {
    if (!pins || !lines) return; // only run for string art
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
console.log(debug);
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, width, height);

   

      // ---------------- THREAD WIDTH CALCULATION ----------------
  const boardCm = debug?.boardSize;    // user board size (cm) → backendல இருந்து pass பண்ணலாம்
  const threadMm = debug?.threadSize ; // user thread thickness (mm)
  const BASE_SIZE = 1000;                    // backend BASE_SIZE

  // 1 mmக்கு எத்தனை px (backend scaleல்)
  const pxPerMm = BASE_SIZE / (boardCm * 10);

  // backend stroke width (px)
  const strokeWidthBackend = threadMm * pxPerMm;

  // preview scale → backend BASE_SIZE இருந்து actual canvas widthக்கு
  const scale = width / BASE_SIZE;

  // final stroke width for preview
  const strokeWidthPreview = strokeWidthBackend * scale;

  ctx.strokeStyle = "black";
  // ctx.lineWidth = strokeWidthPreview;   // ✅ dynamic line width
 // ctx.strokeStyle = "rgba(0,0,0,0.75)";   // 75% opacity instead of full black
ctx.lineWidth = strokeWidthPreview * 0.8; // 80% of calculated width

  // ---------------- DRAW LINES ----------------
  lines.forEach(({ from, to }) => {
    const a = pins[from];
    const b = pins[to];
    ctx.beginPath();
    ctx.moveTo((a.x / BASE_SIZE) * width, (a.y / BASE_SIZE) * height);
    ctx.lineTo((b.x / BASE_SIZE) * width, (b.y / BASE_SIZE) * height);
    ctx.stroke();
  });

    // Draw pins + numbers
    const centerX = width / 2;
    const centerY = height / 2;
    const radius = Math.min(width, height) * 0.4;

    pins.forEach((_, i) => {
      const angle = (i / pins.length) * 2 * Math.PI;
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle);

      // pin dot
      ctx.fillStyle = "black";
      ctx.beginPath();
      ctx.arc(x, y, 2, 0, 2 * Math.PI);
      ctx.fill();

     
    });
  }, [pins, lines, width, height]);


  const handleDownloadPDF = async (fileName) => {
    if (!pins || !lines) return;
    const canvas = canvasRef.current;
    if (!canvas) return;

    const imgDataUrl = canvas.toDataURL("image/png");
    const boardCm = debug?.boardSize;

    // Convert px -> cm based on pin ranges
    const minX = Math.min(...pins.map((p) => p.x));
    const maxX = Math.max(...pins.map((p) => p.x));
    const minY = Math.min(...pins.map((p) => p.y));
    const maxY = Math.max(...pins.map((p) => p.y));

    const pinsCm = pins.map((p) => ({
      xCm: ((p.x - minX) / (maxX - minX)) * boardCm,
      yCm: ((p.y - minY) / (maxY - minY)) * boardCm,
    }));

    const meta = {
      boardSize: boardCm,
      threadSize: debug?.threadSize,
    };
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/create-pdf`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ pins: pinsCm, lines, meta, imageData: imgDataUrl }),
      }
    );

    if (!response.ok) throw new Error("PDF generation failed");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;

    const safeName = fileName.trim().endsWith(".pdf")
      ? fileName.trim()
      : fileName.trim() + ".pdf";

    link.download = safeName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error generating PDF:", err);
  } finally {
    // 🔴 modal close AFTER download trigger
    setTimeout(() => setIsSaveModalOpen(false), 300);
  }
};


  const handleDownloadSVG = () => {
    if (!svg) return;
    const blob = new Blob([svg], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = pins && lines ? "string_art.svg" : "scribble_art.svg";
    link.click();
    URL.revokeObjectURL(url);
  };

  // ----------------- RENDER -----------------
  if (!state) {
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>
        Invalid Preview Access
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>{pins && lines ? "🧵 String Art Preview" : "✏️ Scribble Art Preview"}</Typography>
     
      {pins && lines ? (
        <canvas
          ref={canvasRef}
          width={width}
          height={height}
          style={{ border: "1px solid #ccc", maxWidth: "100%" }}
        />
      ) : svg ? (
        <div style={{ marginTop: "1rem" }}>
          <div
            dangerouslySetInnerHTML={{ __html: svg }}
            style={{ border: "1px solid #ccc", maxWidth: "100%", margin: "0 auto" }}
          />
        </div>
      ) : (
        <p>Loading preview...</p>
      )}

      {/* Download Buttons */}
      {/* <Button onClick={handleDownloadPNG} style={{ marginTop: "1rem" }}>
         Download PNG
      </Button> */}
      <br />
      <br />
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 6 }}>
      <Button variant="contained"
  onClick={() => navigate("/")}
  startIcon={<span style={{ fontSize: 18, lineHeight: 1 }}>🔁</span>}
  disableElevation
   size="small" 
  sx={{
    textTransform: "none",         // UPPERCASE avoid
    fontSize: { xs: 12.5, sm: 14 },
    mt: 2,
    bgcolor: "#111",
    color: "#fff",
    borderRadius: 2,
    px: 1.3,
    py: 0,
    "&:hover": { bgcolor: "#000" },
  }}> Start Over</Button>

      {pins && lines && (
        
        <Button  variant="contained"
   // onClick={handleDownloadPDF}
    onClick={() => {
              // open modal and set default name
              setPendingFileName("string_art_template.pdf");
              setIsSaveModalOpen(true);
            }}
    startIcon={<span style={{ fontSize: 18, lineHeight: 1 }}>📄</span>}
    disableElevation
    sx={{
       textTransform: "none",         // UPPERCASE avoid
    fontSize: { xs: 12.5, sm: 14 },
      mt: 2,
      bgcolor: "#111",
      color: "#fff",
      borderRadius: 2,
      px: 1.3,
      py: 1,
      "&:hover": { bgcolor: "#000" },
    }} >
           Download PDF
        </Button>
        
        
      )}
       </Box>
      {/* {svg && (
        <Button onClick={handleDownloadSVG} style={{ marginTop: "1rem" }}>
           Download SVG
        </Button>
      )} */}
        <SavePdfModal
        open={isSaveModalOpen}
        defaultFileName={pendingFileName}
        onClose={() => setIsSaveModalOpen(false)}
        onSave={(fileName) => handleDownloadPDF(fileName)}
      />
    </div>
  );
};

export default PreviewPage;



